function insensitiveEqual(s1: string, s2: string) {
    return s1?.localeCompare(s2, [], { sensitivity: "accent" }) === 0;
}

function describe(unit?: number, uom?: string, ...pluralizeUoms: string[]) {
    if (!unit) {
        return "";
    }

    uom ??= "";

    if (uom) {
        if (unit > 1 && pluralizeUoms.some(u => insensitiveEqual(u, uom))) {
            uom += "s";
        }
        uom = ` ${uom}`;
    }

    return `${unit}${uom}`.trimEnd();
}

function describeDose(dose?: string, doseUom?: string) {
    doseUom ??= "";
    const pl = ["Application", "Drop", "Inhalation", "Sachet", "Spray", "Tablet"];
    if (dose && isNaN(+dose)) {
        if (pl.some(u => insensitiveEqual(u, doseUom))) {
            doseUom += "s";
        }

        return `${dose} ${doseUom}`.trimEnd();
    }

    return describe(+dose, doseUom, ...pl);
}

function describeInterval(interval?: number, intervalUom?: string) {
    intervalUom ??= (intervalUom ?? "").trimEnd();

    if (intervalUom?.match(/^(As Directed|Stat)$/i)) {
        return intervalUom;
    }

    if (intervalUom?.match(/^(At Night|In the Morning)$/i)) {
        return interval ? `${interval} ${intervalUom}` : intervalUom;
    }

    if (!interval) {
        return "";
    }

    return `${interval} ${intervalUom}`;
}

function describeDuration(duration?: number, durationUom?: string) {
    return describe(duration, durationUom, "Day", "Dose", "Week");
}

function describeQuantity(quantity?: number, quantityUom?: string) {
    return describe(quantity, quantityUom, "Ampoule", "Bottle", "Litre", "Tablet", "Tube");
}

function describeNumberOfPacks(numberOfPacks?: number, numberOfPacksUom?: string) {
    return describe(numberOfPacks, numberOfPacksUom, "pack");
}

const describer: {
    [k in "dose" | "interval" | "duration" | "quantity" | "numberOfPacks"]: (u: string | number, uom: string) => string;
} = {
    dose: describeDose,
    interval: describeInterval,
    duration: describeDuration,
    quantity: describeQuantity,
    numberOfPacks: describeNumberOfPacks
};

export { describer };
